import { configUiPanel_mobile_vertical as  configUiPanel_default} from "src/library/minigame_client/ui/panel"

export let configUiPanel_desktop_horizontal = _.cloneDeep(configUiPanel_default);

const resourcesUiPanel_desktop_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
            "res/common/minigames/sounds/play_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/desktop_horizontal/panel/common.json",
            {name: "res/desktop_horizontal/panel/panel.json", rus: true},

            "res/desktop_horizontal/fonts/font_gold_nums_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_white_nums_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_credits_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_regular_16_currency_desktop_horizontal.xml",
        ]
};

configUiPanel_desktop_horizontal.resources = resourcesUiPanel_desktop_horizontal;
configUiPanel_desktop_horizontal.packFolder = "panel_desktop_horizontal/";
configUiPanel_desktop_horizontal.sndBtnClick = "res/common/minigames/sounds/btn_click";
configUiPanel_desktop_horizontal.sndBtnPlay = "res/common/minigames/sounds/play_click";
configUiPanel_desktop_horizontal.screenWidth = 1920;
configUiPanel_desktop_horizontal.screenHeight = 1080;
configUiPanel_desktop_horizontal.isMobileMode = false;                                // if false - not need res folders digital_panel
configUiPanel_desktop_horizontal.isAccumulateBetMode = false;                         // if false - not need res folders 2div, 2mul, clear, if true - not need light texture in folders bet, min_bet, max_bet
configUiPanel_desktop_horizontal.isNoMinMaxButtons = false;                           // if false - not need res folders min_bet, max_bet
configUiPanel_desktop_horizontal.isHideTotalBet = true;                               // если нужно скрыть валюту и ставку и выводить ее иначе
configUiPanel_desktop_horizontal.isHideCurrencyCredits = false;                       // если нужно скрыть валюту кредитов
configUiPanel_desktop_horizontal.balanceTabPosition = {x: 1536, y: 420};
configUiPanel_desktop_horizontal.buttonPlaceBetPosition = {x: 827, y: 891};
configUiPanel_desktop_horizontal.buttonClearTotalBetPosition = {x: 417, y: 221};
configUiPanel_desktop_horizontal.buttonDivPosition = {x: 49, y: 221};
configUiPanel_desktop_horizontal.buttonMulPosition = {x: 298, y: 221};
configUiPanel_desktop_horizontal.buttonMinPosition = {x: 538, y: 791};
configUiPanel_desktop_horizontal.buttonMaxPosition = {x: 1295, y: 791};
configUiPanel_desktop_horizontal.widthTotalBetTextArea = 500;
configUiPanel_desktop_horizontal.widthCreditsTextArea = 332;
configUiPanel_desktop_horizontal.widthBetButtonTextArea = 87;                         // ширина области для вывода текста(для скалирования текста если не помещается)
configUiPanel_desktop_horizontal.lengthAreaForBetsButtons = 594;                      // ширина(высота) области для размещения кнопок ставок(скалирование кнопок для заполнения всей области)
configUiPanel_desktop_horizontal.lengthBetButton = 91;                                // ширина(высота) кнопки
configUiPanel_desktop_horizontal.offsetBetweenBetButtons = 2;                         // отступ между кнопками
configUiPanel_desktop_horizontal.startBetButtonsPos = {x: 662, y: 793};               // координаты первой кнопки
configUiPanel_desktop_horizontal.isVerticallyDirection = false;                       // вертикально или горизонтально идут кнопки
configUiPanel_desktop_horizontal.labelCredits = {
    pos: {x: 179, y: 49},
    font: {
        name: "font_credits_desktop_horizontal"
    }
};
configUiPanel_desktop_horizontal.labelCurrencyCredits = {
    pos: {x: 300, y: 23},
    font: {name: "arial_regular_16_currency_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelTotalBet = {
    pos: {x: 447 + 163, y: 342 + 103},
    font: {name: "font_credits_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelCurrencyTotalBet = {
    pos: {x: 547 + 163, y: 342 + 103},
    font: {
        name: "arial_regular_16_currency_desktop_horizontal",
        align: "left",
        anchor: {x: 0.0, y: 0.0},
        tint: 0x000000
    }
};
configUiPanel_desktop_horizontal.labelBetButton = {
    pos: {x: 46, y: 14},
    font: {name: "font_gold_nums_desktop_horizontal"}
};
configUiPanel_desktop_horizontal.labelBetLight = {
    pos: {x: 46, y: 14},
    font: {name: "font_white_nums_desktop_horizontal"}
};


//////////////////
// WEBPACK FOOTER
// ./cfg/desktop_horizontal/panel.es6
// module id = 38
// module chunks = 0